/*
We're constantly improving the code you see. 
Please share your feedback here: https://form.asana.com/?k=uvp-HPgd3_hyoXRBw1IcNg&d=1152665201300829
*/

import PropTypes from "prop-types";
import React from "react";
import { AtomoTime } from "../AtomoTime";
import { ButtonSmall } from "../ButtonSmall";
import { MoleculaTokenNumbs } from "../MoleculaTokenNumbs";
import "./style.css";

export const ComponenteToken = ({
  default1,
  buttonActive,
  active,
  error,
  buttonInactive,
  className,
  moleculaTokenNumbsAtomoNumbTokenElementClassName,
  moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName,
  moleculaTokenNumbsAtomoNumbTokenText,
  moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassNameOverride,
  moleculaTokenNumbsAtomoNumbTokenElementClassNameOverride,
  moleculaTokenNumbsAtomoNumbTokenText1,
  moleculaTokenNumbsAtomoNumbTokenDivClassName,
  moleculaTokenNumbsAtomoNumbTokenText2,
  moleculaTokenNumbsAtomoNumbTokenText3,
  moleculaTokenNumbsAtomoNumbTokenElementWrapperClassName,
  moleculaTokenNumbsAtomoNumbTokenDivClassNameOverride,
  moleculaTokenNumbsAtomoNumbTokenElementWrapperClassNameOverride,
  moleculaTokenNumbsDefaultFalseActiveClassName,
  moleculaTokenNumbsAtomoNumbTokenElementClassName1,
  moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName1,
  moleculaTokenNumbsAtomoNumbTokenElementClassName2,
  moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName2,
  atomoTimeSubtitleCopyClassName,
  atomoTimeTimelineClassName,
  atomoTimeRectangleClassName,
  atomoTimeSubtitleCopyClassNameOverride,
  buttonSmallTexto = "Lorem ipsum",
  buttonSmallTextClassName,
  buttonSmallEstado = "activo",
}) => {
  return (
    <div className={`componente-token active-${active} ${className}`}>
      <MoleculaTokenNumbs
        active={active ? true : undefined}
        atomoNumbTokenAtomoNumbTokenClassName={
          moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassNameOverride
        }
        atomoNumbTokenAtomoNumbTokenClassName1={
          moleculaTokenNumbsAtomoNumbTokenElementWrapperClassName
        }
        atomoNumbTokenAtomoNumbTokenClassName2={
          moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName2
        }
        atomoNumbTokenAtomoNumbTokenClassNameOverride={
          moleculaTokenNumbsAtomoNumbTokenElementWrapperClassNameOverride
        }
        atomoNumbTokenDivClassName={
          moleculaTokenNumbsAtomoNumbTokenDivClassNameOverride
        }
        atomoNumbTokenDivClassNameOverride={
          moleculaTokenNumbsAtomoNumbTokenElementClassName1
        }
        atomoNumbTokenElementClassName={
          moleculaTokenNumbsAtomoNumbTokenDivClassName
        }
        atomoNumbTokenElementClassName1={
          moleculaTokenNumbsAtomoNumbTokenElementClassName
        }
        atomoNumbTokenElementClassName2={
          moleculaTokenNumbsAtomoNumbTokenElementClassNameOverride
        }
        atomoNumbTokenElementClassNameOverride={
          moleculaTokenNumbsAtomoNumbTokenElementClassName2
        }
        atomoNumbTokenElementWrapperClassName={
          moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName
        }
        atomoNumbTokenElementWrapperClassNameOverride={
          moleculaTokenNumbsAtomoNumbTokenAtomoNumbTokenClassName1
        }
        atomoNumbTokenText={moleculaTokenNumbsAtomoNumbTokenText1}
        atomoNumbTokenText1={moleculaTokenNumbsAtomoNumbTokenText3}
        atomoNumbTokenText2={moleculaTokenNumbsAtomoNumbTokenText}
        atomoNumbTokenText3={moleculaTokenNumbsAtomoNumbTokenText2}
        className={moleculaTokenNumbsDefaultFalseActiveClassName}
        default1={!default1 ? false : true}
        error={error ? true : undefined}
      />
      <AtomoTime
        className="atomo-time-instance"
        rectangleClassName={atomoTimeRectangleClassName}
        subtitleCopyClassName={atomoTimeSubtitleCopyClassNameOverride}
        subtitleCopyClassNameOverride={atomoTimeSubtitleCopyClassName}
        timelineClassName={atomoTimeTimelineClassName}
      />

      {(buttonActive || buttonInactive) && (
        <ButtonSmall
          className="button-small-instance"
          estado={buttonSmallEstado}
          iconLeft={false}
          iconRigth={false}
          textClassName={buttonSmallTextClassName}
          texto={buttonSmallTexto}
          tipo="link"
        />
      )}
    </div>
  );
};

ComponenteToken.propTypes = {
  default1: PropTypes.bool,
  buttonActive: PropTypes.bool,
  active: PropTypes.bool,
  error: PropTypes.bool,
  buttonInactive: PropTypes.bool,
  moleculaTokenNumbsAtomoNumbTokenText: PropTypes.string,
  moleculaTokenNumbsAtomoNumbTokenText1: PropTypes.string,
  moleculaTokenNumbsAtomoNumbTokenText2: PropTypes.string,
  moleculaTokenNumbsAtomoNumbTokenText3: PropTypes.string,
  buttonSmallTexto: PropTypes.string,
  buttonSmallEstado: PropTypes.string,
};
